<script lang="ts" setup>
import type { Article } from "@/types";

const { blok } = defineProps<{ blok: Article }>();

const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const publishedDate = computed(() => {
  const date = new Date(blok.publishedDate);

  return `${months[date.getMonth()]} ${date.getDate()}, ${date.getFullYear()}`;
});
</script>

<template>
  <div v-editable="blok" class="bg-[#FAF7F4]">
    <Container v-if="blok.heading">
      <div v-editable="blok" class="md:w-[700px] py-12 lg:py-20">
        <div class="flex flex-col gap-[5px]">
          <div class="flex items-start font-helvetica-bold">
            <div>
              {{ publishedDate }} |
              <span class="underline">{{ blok.category }}</span>
            </div>
          </div>
          <Heading :heading="blok.heading" heading-level="h1" />
        </div>
      </div>
    </Container>

    <FullColumnContent
      v-if="blok?.content"
      :blok="blok?.content[0]"
      class="-mt-10"
    />

    <div v-if="blok && blok.body">
      <component
        :is="item.component"
        v-for="item in blok.body"
        :key="item._uid"
        :blok="item"
      />
    </div>

    <Container class="pt-10 pb-20">
      <div class="flex flex-col gap-2.5">
        <div class="text-[20px] font-helvetica-bold">Tags</div>
        <div>{{ blok.tags?.join(", ") }}</div>
      </div>
    </Container>
  </div>
</template>
